export interface PhotoLibraryItem {
  id: string;
  name: string;
  path: string;
  url?: string;
}

export interface PhotoLibraryGroup {
  label: string;
  items: PhotoLibraryItem[];
}

export interface PhotoLibraryManifest {
  version: number;
  categories: Record<string, { groups: PhotoLibraryGroup[] }>;
}

export function isLibraryUrl(url: string): boolean {
  return url.includes('item-photo-library');
}

export function getPhotoSource(photoUrl?: string | null): 'library' | 'upload' | 'none' {
  if (!photoUrl) return 'none';
  return isLibraryUrl(photoUrl) ? 'library' : 'upload';
}
